<template>
  <div>
    <Header />

    <div class="container-fluid users-container">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <DivvyAdminSidebar />
        </div>

        <transition appear name="fade">
          <div class="col-md-9 right-container">
            <div class="col-md-12 pt-4">
              <!--  -->
              <h4>Create security role</h4>
              <p>
                Enter the number of key authorizations and the role to clone or
                choose no cloning.
              </p>

              <form class="">
                <fieldset class="border rounded p-2 mb-2">
                  <div class="form-group">
                    <label for="SecLabel">Name your security role:</label>
                    <input
                      type="text"
                      class="form-control"
                      name="SecLabel"
                      id="SecLabel"
                      maxsize="25"
                      required=""
                      v-model="Role"
                    />
                  </div>
                  <hr />
                  <div class="form-group">
                    <label for="keynum"
                      >Choose role to clone and the number of keys to
                      add:</label
                    >
                    <div class="row">
                      <div class="col-md-4">
                        <select
                          name="keynum"
                          class="form-control"
                          v-model="Keys"
                        >
                          <option :value="+0">0</option>
                          <option :value="+1">1</option>
                          <option :value="+2">2</option>
                          <option :value="+3">3</option>
                          <option :value="+4">4</option>
                          <option :value="+5">5</option>
                          <option :value="+6">6</option>
                          <option :value="+7">7</option>
                          <option :value="+8">8</option>
                          <option :value="+9">9</option>
                          <option :value="+10">10</option>
                          <option :value="+11">11</option>
                          <option :value="+12">12</option>
                          <option :value="+13">13</option>
                          <option :value="+14">14</option>
                          <option :value="+15">15</option>
                          <option :value="+16">16</option>
                          <option :value="+17">17</option>
                          <option :value="+18">18</option>
                          <option :value="+19">19</option>
                          <option :value="+20">20</option>
                          <option :value="+21">21</option>
                          <option :value="+22">22</option>
                          <option :value="+23">23</option>
                          <option :value="+24">24</option>
                          <option :value="+25">25</option>
                          <option :value="+26">26</option>
                          <option :value="+27">27</option>
                          <option :value="+28">28</option>
                          <option :value="+29">29</option>
                          <option :value="+30">30</option>
                          <option :value="+31">31</option>
                          <option :value="+32">32</option>
                        </select>
                      </div>
                      <div class="col-md-8">
                        <select
                          name="authnum"
                          class="form-control"
                          v-model="Clone"
                        >
                          <!-- <option value="0">Select a Role</option> -->
                          <option :value="+0">- No Cloning -</option>
                          <option
                            v-for="role in getSecurityRolesData"
                            :key="role.sec_id"
                            :value="+role.sec_id"
                            >{{ role.label }}</option
                          >
                        </select>
                      </div>
                    </div>
                  </div>
                </fieldset>
                <div class="form-group">
                  <button
                    type="button"
                    class="btn btn-primary"
                    @click="goToEditKeysPage"
                  >
                    Continue
                  </button>
                  <!-- <router-link
                    class="btn btn-primary"
                    :to="{ name: 'DivvyAdminManageEditKeysPage', params: {
                      role: Role, 
                      keys: Keys,
                      clone: Clone,
                    } }"
                  >
                    Continue
                  </router-link> -->
                  <router-link
                    style="color: white;"
                    class="ml-2 btn btn-danger"
                    :to="{ name: 'DivvyAdminManageSecurityRoles' }"
                  >
                    Cancel
                  </router-link>
                </div>
              </form>
              <!--  -->
            </div>
          </div>
        </transition>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import DivvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";

export default {
  name: "CreateSecurityRole",
  data() {
    return {
      getSecurityRolesData: [],
      Keys: 4,
      Role: "",
      Clone: 0,
    };
  },
  components: {
    Header,
    Footer,
    DivvyAdminSidebar,
  },
  methods: {
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "manageRoles",
        activeMenu: this.activeMenu ? this.activeMenu : "security",
      });
    },
    goToEditKeysPage() {
      if (this.Role === "") {
        alert("Enter security role name.");
        return;
      }

      this.$router.push({
        name: "DivvyAdminManageEditKeysPage",
        params: {
          role: this.Role,
          keys: this.Keys,
          clone: this.Clone,
        },
      });
    },
  },
  created() {
    this.setActiveMenuItem();
    this.$store
      .dispatch("manageRoles/fetchSecurityRoles", {
        pg_num: 0,
        pg_size: 0,
        searchterm: "",
      })
      .then((data) => {
        console.log(data);
        this.getSecurityRolesData = data.result;
      });
  },
};
</script>

<style lang="scss" scoped>
.users-container {
  min-height: 100%;
  margin: -14px 0 0 0;
}
</style>
